import React from "react";

const AboutUsSection = () => {
  return (
    <div
      className="section-full site-bg-light twm-abus-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="row">
        
        {/* Left Content */}
        <div className="col-lg-6 col-md-12">
          <div className="twm-abus-st2-section">

            <div className="section-head left">
              <div className="twm-sm-title left">About Velocity Cab</div>

              <h2 className="twm-large-title site-text-dark">
                Reliable Cab Services for Safe & Comfortable Travel
              </h2>

              <div className="section-head-detail">
                Velocity Cab is dedicated to providing safe, affordable, and
                hassle-free travel experiences. Whether you need a local ride
                or an outstation trip, our professional drivers and
                well-maintained vehicles ensure a smooth and comfortable journey
                every time.
              </div>
            </div>

            {/* Features List */}
            <div className="twm-inline-list2">
              <ul>
                <li>
                  <i className="fa fa-car"></i> All Types of Vehicles Available
                </li>
                <li>
                  <i className="fa fa-clock"></i> 24/7 Service Availability
                </li>
                <li>
                  <i className="fa fa-map-marker"></i> Local & Outstation Trips
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Right Image Section */}
        <div
          className="col-lg-6 col-md-12 twm-abus2-right-pic"
          style={{ backgroundImage: "url(images/car.png)" }}
        >
        </div>

      </div>
    </div>
  );
};

export default AboutUsSection;